export default function Footer() {
  return <footer style={{
    backgroundColor: 'rgb(31, 58, 46)',
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'repeat',
    color: 'rgb(255, 255, 255)',
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: '64px',
    paddingBottom: '48px',
    position: 'relative',
    overflow: 'hidden'
  }}>
      <div className="page-container">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-10 md:gap-0">
          <div className="flex flex-col" style={{
          maxWidth: '340px'
        }}>
            <div className="flex items-center" style={{
            gap: '8px'
          }}>
              <div className="flex items-center justify-center flex-shrink-0" style={{
              width: '32px',
              height: '32px',
              borderRadius: '9999px',
              border: '1.5px solid #C8985C',
              color: '#C8985C',
              fontFamily: 'Georgia, ui-serif, serif',
              fontWeight: '700',
              fontSize: '16px'
            }}>
                Q
              </div>
              <span style={{
              fontFamily: 'Georgia, ui-serif, serif',
              fontWeight: '700',
              fontSize: '20px',
              color: '#FFFFFF',
              letterSpacing: '-0.01em'
            }}>
                PrepayQR
              </span>
            </div>

            <p style={{
            color: 'rgba(255, 252, 247, 0.7)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '20px',
            marginTop: '16px',
            fontStyle: 'italic'
          }}>
              "PrepayQR. Built for therapists, by operators."
            </p>

            <div className="flex items-center flex-wrap" style={{
            marginTop: '16px',
            gap: '12px'
          }}>
              <span style={{
              border: '1px solid #C8985C',
              borderRadius: '9999px',
              padding: '4px 12px',
              color: '#C8985C',
              fontSize: '12px',
              fontWeight: '400',
              backgroundColor: 'transparent',
              display: 'inline-block',
              lineHeight: '20px'
            }}>
                3% Flat Commission Only
              </span>
              <span style={{
              color: 'rgba(255, 252, 247, 0.7)',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px'
            }}>
                No Monthly Fees
              </span>
            </div>
          </div>

          <div className="flex flex-col">
            <span style={{
            color: 'rgba(255, 252, 247, 0.7)',
            fontSize: '12px',
            fontWeight: '600',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            lineHeight: '20px'
          }}>
              PRODUCT
            </span>
            <ul className="flex flex-col" style={{
            marginTop: '16px',
            gap: '12px',
            listStyle: 'none',
            padding: 0,
            margin: 0,
            marginBlockStart: '16px'
          }}>
              <li style={{
              color: 'rgba(255, 252, 247, 0.7)',
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px',
              textAlign: 'left'
            }}>
                <a href="#" style={{
                color: 'rgba(255, 252, 247, 0.7)',
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                textDecoration: 'none',
                textAlign: 'left',
                transition: 'color 150ms ease'
              }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 1)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 0.7)'}>
                  How It Works
                </a>
              </li>
              <li style={{
              color: 'rgba(255, 252, 247, 0.7)',
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px',
              textAlign: 'left'
            }}>
                <a href="#" style={{
                color: 'rgba(255, 252, 247, 0.7)',
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                textDecoration: 'none',
                textAlign: 'left',
                transition: 'color 150ms ease'
              }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 1)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 0.7)'}>
                  The Science
                </a>
              </li>
              <li style={{
              color: 'rgba(255, 252, 247, 0.7)',
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px',
              textAlign: 'left'
            }}>
                <a href="#" style={{
                color: 'rgba(255, 252, 247, 0.7)',
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                textDecoration: 'none',
                textAlign: 'left',
                transition: 'color 150ms ease'
              }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 1)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 0.7)'}>
                  ROI Calculator
                </a>
              </li>
              <li style={{
              color: 'rgba(255, 252, 247, 0.7)',
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px',
              textAlign: 'left'
            }}>
                <a href="#" style={{
                color: 'rgba(255, 252, 247, 0.7)',
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                textDecoration: 'none',
                textAlign: 'left',
                transition: 'color 150ms ease'
              }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 1)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 0.7)'}>
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col">
            <span style={{
            color: 'rgba(255, 252, 247, 0.7)',
            fontSize: '12px',
            fontWeight: '600',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            lineHeight: '20px'
          }}>
              CONTACT
            </span>

            <p style={{
            color: 'rgba(255, 252, 247, 0.7)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '20px',
            marginTop: '12px'
          }}>
              Have questions before starting?
            </p>

            <div className="flex items-center" style={{
            marginTop: '8px',
            gap: '8px'
          }}>
              <span style={{
              color: '#C8985C',
              display: 'flex',
              alignItems: 'center',
              width: '16px',
              height: '16px',
              flexShrink: 0
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.21 12.9a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </span>
              <a href="tel:1-951-965-1720" style={{
              color: '#C8985C',
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: '18px',
              fontWeight: '600',
              lineHeight: '24px',
              textDecoration: 'none',
              transition: 'opacity 150ms ease'
            }} onMouseEnter={e => e.currentTarget.style.opacity = '0.8'} onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                1-951-965-1720
              </a>
            </div>

            <div className="flex items-center" style={{
            marginTop: '12px',
            gap: '8px'
          }}>
              <span style={{
              color: '#C8985C',
              display: 'flex',
              alignItems: 'center',
              width: '16px',
              height: '16px',
              flexShrink: 0
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </span>
              <p style={{
              color: 'rgba(255, 252, 247, 0.7)',
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px',
              margin: 0
            }}>
                Daily settlements. PCI Compliant. Bank-level security.
              </p>
            </div>
          </div>
        </div>

        <div style={{
        borderTop: '1px solid rgba(255, 252, 247, 0.15)',
        marginTop: '32px',
        paddingTop: '24px'
      }} className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 md:gap-0">
          <p style={{
          color: 'rgba(255, 252, 247, 0.7)',
          fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '20px',
          margin: 0
        }}>
            © 2026 PrepayQR. All rights reserved.
          </p>

          <div className="flex items-center flex-wrap" style={{
          gap: '24px'
        }}>
            <a href="#" style={{
            color: 'rgba(255, 252, 247, 0.7)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '20px',
            textDecoration: 'none',
            transition: 'color 150ms ease'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 1)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 0.7)'}>
              Privacy Policy
            </a>
            <a href="#" style={{
            color: 'rgba(255, 252, 247, 0.7)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '20px',
            textDecoration: 'none',
            transition: 'color 150ms ease'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 1)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 0.7)'}>
              Terms of Service
            </a>
            <a href="#" style={{
            color: 'rgba(255, 252, 247, 0.7)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '20px',
            textDecoration: 'none',
            transition: 'color 150ms ease'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 1)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255, 252, 247, 0.7)'}>
              Security Standards
            </a>
          </div>
        </div>
      </div>
    </footer>;
}